import _ from 'lodash'

export default {
  name: 'KListItem',
  props: {
    to: { // 路由对象
      type: [Object, String],
      // null
      default() {
        return null
      },
    },
  },
  computed: {
    isLayoutVertical() {
      let parent = this.$parent
      while (parent && parent.$options.componentName !== 'KList') {
        parent = parent.$parent
      }
      return parent ? parent.itemLayout === 'vertical' : false
    },
  },
  methods: {
    renderMetaAvatar() {
      if (!this.$slots.avatar) {
        return null
      }
      return (
        <div class="km-list-item__avatar">
          {this.$slots.avatar}
        </div>
      )
    },
    renderMetaTitle() {
      if (!this.$slots.title) {
        return null
      }
      return (
        <div class="km-list-item__title">
          {this.$slots.title}
        </div>
      )
    },
    renderMetaDescription() {
      if (!this.$slots.description) {
        return null
      }
      return (
        <div class="km-list-item__description">
          {this.$slots.description}
        </div>
      )
    },
    renderMeta() {
      const avatar = this.renderMetaAvatar()
      const title = this.renderMetaTitle()
      const description = this.renderMetaDescription()

      const content = (title || description)
        ? (
          <div class="km-list-item__content">
            {title}
            {description}
          </div>
        ) : null

      return (avatar || content)
        ? (
          <div class="km-list-item__meta">
            {avatar}
            {content}
          </div>
        ) : null
    },
    renderActions() {
      if (!this.$slots.actions) {
        return null
      }
      return (
        <div class="km-list-item__actions">
          {this.$slots.actions}
        </div>
      )
    },
    renderMain() {
      const meta = this.renderMeta()
      const defaultContent = this.$slots.default
      const actions = this.renderActions()

      if (!meta && !defaultContent && !actions) {
        return
      }

      return (
        <div class="km-list-item__main">
          {meta}
          {defaultContent}
          {actions}
        </div>
      )
    },
    renderExtra() {
      if (!this.$slots.extra) {
        return null
      }

      return (
        <div class="km-list-item__extra">
          {this.$slots.extra}
        </div>
      )
    },
    handleClick() {
      this.$emit('click')
    },
  },
  render() {
    const css = {
      'km-list__item': true,
    }

    const props = {}

    const events = {}

    const nativeEvents = {}

    let tag = 'div'

    const data = {
      class: css,
      props,
      on: events,
    }

    if (this.to) {
      props.to = this.to
      tag = 'router-link'
      nativeEvents.click = this.handleClick
      _.assign(data, { nativeOn: nativeEvents })
    } else {
      events.click = this.handleClick
    }

    const extra = this.renderExtra()

    if (extra) {
      const main = this.renderMain()
      return (
        <tag
          {...data}
        >
          {main}
          {extra}
        </tag>
      )
    }

    if (this.isLayoutVertical) {
      css['km-list__item--no-flex'] = true
    }

    const meta = this.renderMeta()
    const actions = this.renderActions()

    return (
      <tag
        {...data}
      >
        {meta}
        {this.$slots.default}
        {actions}
      </tag>
    )
  },
}
